"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.planes = void 0;
exports.planes = {
    "40": {
        nombre: "40",
        descripcion: "Básico con hasta 40 comprobantes emitidos al año móvil",
        importeMensual: "333,00",
        importeAnual: "3197,00",
        limiteComprobantes: "40",
        activo: false
    },
    "50": {
        nombre: "50",
        descripcion: "Básico con hasta 50 comprobantes emitidos al año móvil",
        importeMensual: "483,00",
        importeAnual: "4637,00",
        limiteComprobantes: "50",
        activo: true
    },
    ilimitado: {
        nombre: "ilimitado",
        descripcion: "Básico servicios, comprobantes ilimitados y sin control de stock",
        importeMensual: "930,00",
        importeAnual: "8928,00",
        limiteComprobantes: "ilimitado",
        activo: true
    },
    stock: {
        nombre: "stock",
        descripcion: "Básico con comprobantes ilimitados, con control de stock para una sucursal",
        importeMensual: "2030,00",
        importeAnual: "19488,00",
        limiteComprobantes: "ilimitado",
        activo: true
    },
    comboHandy: {
        nombre: "comboHandy",
        descripcion: "Facturación únicamente desde pos Handy",
        importeMensual: "439,00",
        importeAnual: "4214,00",
        limiteComprobantes: "ilimitado",
        activo: false
    }
};
